export default __webpack_public_path__ + "static/media/jpm.1f759223.svg";